const SLACK_OAUTH_STATE_KEY = "mem.slack.oauth_state";

export const writeSlackOAuthState = (state: string) => {
  window.localStorage.setItem(SLACK_OAUTH_STATE_KEY, state);
};

export const readSlackOAuthState = (): string | null => {
  return window.localStorage.getItem(SLACK_OAUTH_STATE_KEY);
};

export const clearSlackOAuthState = () => {
  window.localStorage.removeItem(SLACK_OAUTH_STATE_KEY);
};
